module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp2_9006.c3681c94.png";